import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { api } from "@/lib/api";

export default function ProfileBorrows() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/borrow/my").then((r) => setData(r.data));
  }, []);
  if (!data) return <p className="text-sm text-slate-400 py-6 text-center">Loading…</p>;
  const fmt = (d) => (d ? new Date(d).toLocaleDateString() : "—");
  return (
    <div>
      <div className="mb-4 p-3 rounded-lg bg-indigo-50 dark:bg-indigo-950 text-sm">
        You've borrowed <strong>{data.month_count}</strong> of <strong>{data.limit}</strong> books this month.
      </div>
      {data.borrows.length === 0 ? (
        <p className="text-sm text-slate-400 py-8 text-center">No active borrowed books.</p>
      ) : (
        <div className="space-y-2">
          {data.borrows.map((b) => (
            <div key={b.id} data-testid="my-borrow-item"
              className="flex items-center justify-between p-3 rounded-lg border border-slate-200 dark:border-slate-800">
              <div>
                <p className="text-sm font-semibold">{b.book?.title || "Book"}</p>
                <p className="text-xs text-slate-500">{b.book?.author}</p>
              </div>
              <p className="text-xs text-amber-600 flex items-center gap-1">
                <Clock className="h-3.5 w-3.5" /> Due {fmt(b.due_date)}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
